import React, { useCallback, useState, useEffect } from 'react';
import Label from 'components/Form/Label';
import { StyledTextInput } from './WizardStyled';

const NumericInput = ({
  inputLabel,
  initialValue,
  id,
  onChange,
  minValue = 0.1,
  maxValue = 10000,
  theme = 'default',
  stepValue = 0.1,
  integer = false,
  small,
  disabled,
  icon,
  title,
}) => {
  const [updateParameter, setUpdateParameter] = useState(initialValue);

  const handleOnChange = useCallback((e) => {
    let value = e.target.value;
    value = value && parseFloat(value);

    setUpdateParameter(value);
    e.target.focus();
  }, []);

  useEffect(() => {
    setUpdateParameter(initialValue);
  }, [initialValue]);

  const handleOnBlur = useCallback(
    (e) => {
      let value = e.target.value;
      value = parseFloat(value || 0);
      if (value >= minValue && value <= maxValue && onChange) {
        const toReturn = integer ? parseInt(value, 10) : value;
        onChange(toReturn, id);
        setUpdateParameter(toReturn);
      } else {
        setUpdateParameter(initialValue);
      }

      if (onChange) {
        onChange(value, id);
      }
    },
    [minValue, maxValue, onChange, initialValue, id, integer],
  );

  return (
    <div>
      <Label theme={theme}>{inputLabel}</Label>
      <StyledTextInput
        theme={theme}
        id={id}
        small={small}
        type="number"
        pattern="[0-9]*"
        inputMode="numeric"
        min={minValue}
        max={maxValue}
        step={integer ? 1 : stepValue}
        value={updateParameter}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        disabled={disabled}
        icon={icon}
        title={title}
      />
    </div>
  );
};

export default NumericInput;
